import invariant from "invariant";

import { StrapiImageInterface } from "@/types/strapi";

/**
 * Strapi Image Resolver
 *
 * Resolve strapi image queries to ensure image data is there
 *
 * @param image
 * @returns
 */
export const strapiImageResolver = (image: StrapiImageInterface) => {
  invariant(image?.cloudinaryMedia?.gatsbyImageData, "strapi image gatsbyImageData is required");
  return {
    childImageSharp: {
      gatsbyImageData: image.cloudinaryMedia.gatsbyImageData,
    },
  };
};
